"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _axios = _interopRequireDefault(require("axios"));

var _formToObject = _interopRequireDefault(require("form-to-object"));

var _formUrlencoded = _interopRequireDefault(require("form-urlencoded"));

var _helpers = require("utils/helpers");

var ProductForm = /*#__PURE__*/function () {
  function ProductForm(component) {
    (0, _classCallCheck2["default"])(this, ProductForm);
    this.dom = {
      $window: window,
      $component: component,
      $form: component.querySelector('.js-product-form'),
      $formContainer: component.querySelector('.js-product-form'),
      $description: component.querySelector('.js-productForm-quantity-description'),
      $increment: component.querySelector('.js-productForm-increment'),
      $radios: Array.from(component.querySelectorAll('.js-productForm-quantity-button')),
      $productSwitcher: document.querySelector('.js-productForm-productSwitcher'),
      $submitButton: component.querySelector('.js-productForm-submit')
    }, this.state = {
      isShitBrowser: (0, _helpers.isOldIE)(),
      maxQuantity: this.dom.$increment != null ? parseInt(this.dom.$increment.dataset.maxQuantity) : '',
      defaultQuantity: this.dom.$increment ? parseInt(this.dom.$increment.dataset.defaultQuantity) : ''
    };
    this.submitHandler = this.ajaxSubmit.bind(this);
    this.mount();
  }

  (0, _createClass2["default"])(ProductForm, [{
    key: "mount",
    value: function mount() {
      var dom = this.dom,
          state = this.state;
      var self = this;
      console.log('ProductForm : mount', this);

      if (dom.$form && !state.isShitBrowser) {
        dom.$form.addEventListener('submit', this.submitHandler);
      }

      if (dom.$radios.length) {
        dom.$radios.forEach(function ($radio) {
          return $radio.addEventListener('click', function (event) {
            return self.setDescription(event);
          });
        });
        this.setDescription();
      }

      if (dom.$increment != null) {
        this.initincrementor();
      }
    }
  }, {
    key: "unmount",
    value: function unmount() {
      var dom = this.dom,
          state = this.state;
      console.log('ProductForm : unmount', this);

      if (dom.$form) {
        dom.$form.removeEventListener('submit', this.submitHandler);
      }
    } // Init incrementor event functionality 

  }, {
    key: "initincrementor",
    value: function initincrementor() {
      var dom = this.dom,
          state = this.state; // set innitial quanity value

      this.qtyValue = state.defaultQuantity;
      this.qtyInputEvent();
      this.qtyBtnEvent();
    }
  }, {
    key: "qtyInputEvent",
    value: function qtyInputEvent() {
      var _this = this;

      var dom = this.dom,
          state = this.state;
      this.qtyInput = dom.$increment.querySelector('.increment__input'); // qty selectors onchange

      if (this.qtyInput != null) {
        this.qtyInput.addEventListener('change', function () {
          _this.qtyValue = parseInt(_this.qtyInput.value, 10); // dont accept 0 or empty or NaN

          if (Number.isNaN(_this.qtyValue) || _this.qtyValue === 0) {
            _this.qtyValue = state.defaultQuantity;
          }

          _this.disableMinusBtn(); // dont accept negative values


          _this.qtyInput.value = Math.abs(_this.qtyValue);
        }, false);
      }
    }
  }, {
    key: "qtyBtnEvent",
    value: function qtyBtnEvent() {
      var _this2 = this;

      var dom = this.dom,
          state = this.state;
      this.qtyBtnPlus = dom.$increment.querySelector('.increment__btn--plus');
      this.qtyBtnMinus = dom.$increment.querySelector('.increment__btn--minus');
      this.qtyBtns = [this.qtyBtnMinus, this.qtyBtnPlus]; // qty selectors onchange

      if (this.qtyBtns[0] != null) {
        this.qtyBtns.forEach(function (btn) {
          ['click', 'keypress'].forEach(function (event) {
            btn.addEventListener(event, function (e) {
              if (e.which === 13 || e.type === 'click') {
                var isPlus = btn.classList.contains('increment__btn--plus'); // increment / decrement

                if (isPlus && _this2.qtyValue < state.maxQuantity) {
                  // if increment has not reached max input increase value
                  _this2.qtyValue = _this2.qtyValue !== state.maxQuantity ? _this2.qtyValue + state.defaultQuantity : _this2.qtyValue;
                } else if (_this2.qtyValue > state.defaultQuantity) {
                  // decrease value
                  _this2.qtyValue = _this2.qtyValue - state.defaultQuantity;
                }

                _this2.disableMinusBtn(); // update the value


                _this2.qtyInput.value = Math.abs(_this2.qtyValue);
              }
            }, false);
          });
        });
      }
    }
  }, {
    key: "disableMinusBtn",
    value: function disableMinusBtn() {
      var dom = this.dom,
          state = this.state; // if input value equals innitial default value add disable

      if (this.qtyValue === state.defaultQuantity) {
        this.qtyBtns[0].classList.add('increment__btn--disabled'); // else if input value equals max input add disable
      } else if (this.qtyValue === state.maxQuantity) {
        this.qtyBtns[1].classList.add('increment__btn--disabled'); // else remove disable
      } else {
        this.qtyBtns.forEach(function (btn) {
          btn.classList.remove('increment__btn--disabled');
        });
      }
    }
  }, {
    key: "setDescription",
    value: function setDescription(event) {
      var dom = this.dom,
          state = this.state;
      console.log('ProductForm : setDescription', this, event);
      var radio = event ? event.target : dom.$radios.filter(function ($radio) {
        return $radio.checked;
      })[0];
      var description = radio && radio.dataset.quantityDescription ? radio.dataset.quantityDescription : '';
      dom.$description.textContent = description;
    }
  }, {
    key: "ajaxSubmit",
    value: function ajaxSubmit(event) {
      var _this3 = this;

      var dom = this.dom,
          state = this.state;
      console.log('ProductForm : ajaxSubmit', this, event);
      event.preventDefault();
      event.stopPropagation();
      var data = (0, _formToObject["default"])(dom.$form);

      if (!data.id) {
        if (dom.$productSwitcher) {
          dom.$productSwitcher.classList.add('ProductDetails__switcher--error');
          dom.$submitButton.value = dom.$submitButton.dataset.error;

          if (dom.$window.innerWidth < 1024) {
            var rect = dom.$productSwitcher.getBoundingClientRect();
            dom.$window.scrollTo({
              top: rect.top + dom.$window.scrollY - 20,
              left: 0,
              behavior: 'smooth'
            });
          }
        }

        return false;
      }

      dom.$formContainer.classList.add('ProductForm__container--loading');
      dom.$submitButton.value = ""; // delay input value update after cart update 
      // for more declaritive user experince

      setTimeout(function () {
        _this3.qtyInput.value = state.defaultQuantity;
        _this3.qtyValue = state.defaultQuantity;
      }, 1500);
      (0, _axios["default"])({
        method: 'post',
        url: dom.$form.action,
        data: (0, _formUrlencoded["default"])(data)
      }).then(function (response) {
        var customEvent = new CustomEvent('updateMiniCart', {
          detail: response.data
        });
        document.dispatchEvent(customEvent);
        setTimeout(function () {
          dom.$formContainer.classList.remove('ProductForm__container--loading');
          dom.$submitButton.value = dom.$submitButton.dataset.value;
        }, 500);
      })["catch"](function (response) {
        console.log(response);
        window.location.reload();
      });
    }
  }]);
  return ProductForm;
}();

exports["default"] = ProductForm;